exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Alegreya+Sans+SC:900);", ""]);

// module
exports.push([module.id, ".bold{font-family:Alegreya Sans SC,sans-serif}.header{background-color:#f5f5f5;border-style:none;border-bottom:thin solid #d1d0cf;border-bottom-width:2px}", "", {"version":3,"sources":["/home/circleci/repo/src/components/modal/RegistrationComponent.vue"],"names":[],"mappings":"AAEA,MACE,uCAA4C,CAC7C,AACD,QACE,yBAAqC,AACrC,kBAAmB,AACnB,iCAAkC,AAClC,uBAAyB,CAC1B","file":"RegistrationComponent.vue","sourcesContent":["\n@import url('https://fonts.googleapis.com/css?family=Alegreya+Sans+SC:900');\n.bold {\n  font-family: 'Alegreya Sans SC', sans-serif;\n}\n.header {\n  background-color: rgb(245, 245, 245);\n  border-style: none;\n  border-bottom: thin solid #d1d0cf;\n  border-bottom-width: 2px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a0a7131a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modal/RegistrationComponent.vue
// module id = 1168
// module chunks = 19 27